import { ContractorIndividualItem } from 'bus/contractorIndividual/types';
import { ContractorLegalItem } from 'bus/contractorLegal/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { ContractorItem } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorList: builder.query<ContractorItem[], void>({
      query: () => ({
        url: '/v1/Contractor',
      }),
    }),
    getContractorDetailInfo: builder.query<ContractorIndividualItem | ContractorLegalItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Contractor/${data.id}`,
      }),
    }),
  }),
});

export const {
  useGetContractorDetailInfoQuery,
  useGetContractorListQuery,
  useLazyGetContractorDetailInfoQuery,
  useLazyGetContractorListQuery,
} = request;
